import { api } from './client.js';

export const systemApi = {
  health: () => api.get('/admin/system/health'),
  metrics: () => api.get('/admin/system/metrics'),
  maintenance: () => api.get('/admin/system/maintenance'),
  enableMaintenance: (body) => api.post('/admin/system/maintenance/enable', body),
  disableMaintenance: (body) => api.post('/admin/system/maintenance/disable', body),

  invalidateCache: (tags) => api.post('/admin/cache/invalidate', { tags }),
  purgeAllCache: () => api.post('/admin/cache/purge-all')
};
